import { NavLink, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

import '../estilos/sidebarAdmin.css';
 
function SidebarAdmin({ usuario, setUsuario }){

    const navigate  = useNavigate();
    const location  = useLocation();
    const username  = usuario?.username || usuario?.nombre || "admin";
    const avatar = usuario?.avatar || "/imagenes/marca/avatar.png";

    const menuOperacion = [
      { label: "Usuarios", icono: "bi-people", to: "/admin/usuarios" },
      { label: "Servicios", icono: "bi-briefcase", to: "/admin/servicios",
        sub: [
          { label: "Por categoría", icono: "bi-grid",    to: "/admin/categorias-servicios" },
          { label: "Por usuario",   icono: "bi-person",  to: "/admin/servicios-por-usuarios" },
        ]
      },
      { label: "Reservas", icono: "bi-calendar-check", to: "/admin/reservas",
        sub: [
          { label: "Por usuario", icono: "bi-person", to: "/admin/reservas-por-usuario" },
        ]
      },
      { label: "Búsquedas", icono: "bi-search", to: "/admin/busquedas" },
      { label: "Soporte", icono: "bi-headset", to: "/admin/soporte" },
      { label: "Reclamos", icono: "bi-exclamation-triangle", to: "/admin/reclamos" },
      { label: "Reseñas", icono: "bi-star", to: "/admin/resenas" },
    ];

    const menuPagos = [
      { label: "Pagos recibidos", icono: "bi-credit-card", to: "/admin/pagos" },
      { label: "Desembolsos", icono: "bi-bank", to: "/admin/desembolsos" },
      { label: "Conciliación Wompi", icono: "bi-shield-check", to: "/admin/conciliacion-wompi" },
      { label: "Reportes", icono: "bi-bar-chart", noNav: true,
        sub: [
          { label: "Por usuarios",  icono: "bi-person-lines-fill",   to: "/admin/reportes-por-usuarios"  },
          { label: "Por servicios", icono: "bi-briefcase",           to: "/admin/reportes-por-servicios" },
          { label: "Por reservas",  icono: "bi-calendar-check-fill", to: "/admin/reportes-por-reservas"  },
          { label: "De pagos",      icono: "bi-cash-coin",           to: "/admin/reportes-pagos"         },
        ]
      },
    ];

    const esSoporte = usuario?.tipo === "Soporte";

    const menuAdmin = [
      ...(usuario?.tipo === "SuperAdmin" ? [{ label: "Registrar administrador", icono: "bi-person-plus", to: "/admin/registrar-admin" }] : []),
      { label: "Mi cuenta", icono: "bi-person-circle", to: "/admin/mi-cuenta" },
    ];

    function handleLogOut(event){
        event.preventDefault();
    
        localStorage.clear(); // Limpiamos el almacenamiento local.
        axios.post("/cerrar-sesion")
        .then(function(response) {
            //console.log(response);
            if (typeof setUsuario === "function") setUsuario(null); // aseguramos que setUsuario exista para ponerlo en null.
            navigate("/"); //  Redirige a la página principal
            return window.location.reload();
        })
        .catch(function(error) { console.error("Error al cerrar sesión:", error); });
    }

    function renderItem(item){
      const tieneSubMenu = item.sub && item.sub.length > 0;
      const subItemActivo = tieneSubMenu && item.sub.some(s => location.pathname === s.to);
      const subActivo = tieneSubMenu && (
        (!item.noNav && location.pathname === item.to) ||
        subItemActivo
      );

      const sublist = tieneSubMenu && subActivo && (
        <ul className="zv-admin-sidebar-sublist">
          {item.sub.map(sub => (
            <li key={sub.to}>
              <NavLink
                to={sub.to}
                className={({ isActive }) => `zv-admin-sidebar-sublink ${isActive ? "active" : ""}`}
              >
                <i className={`bi ${sub.icono}`}></i>
                <span>{sub.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      );

      const chevron = tieneSubMenu && (
        <i className={`bi bi-chevron-${subActivo ? "up" : "down"} ms-auto`} style={{ fontSize: 11, opacity: 0.5 }}></i>
      );

      if (item.noNav) {
        return (
          <li className="zv-admin-sidebar-item" key={item.label}>
            <button
              type="button"
              className="zv-admin-sidebar-link w-100 border-0 bg-transparent text-start"
              onClick={() => {
                if (tieneSubMenu && item.sub?.[0]?.to) navigate(item.sub[0].to);
              }}
            >
              <span className="zv-admin-sidebar-icon">
                <i className={`bi ${item.icono}`}></i>
              </span>
              <span>{item.label}</span>
              {chevron}
            </button>
            {sublist}
          </li>
        );
      }

      return (
        <li className="zv-admin-sidebar-item" key={item.to}>
          <NavLink
            to={item.to}
            className={({ isActive }) => `zv-admin-sidebar-link ${isActive ? "active" : ""}`}
          >
            <span className="zv-admin-sidebar-icon">
              <i className={`bi ${item.icono}`}></i>
            </span>
            <span>{item.label}</span>
            {chevron}
          </NavLink>
          {sublist}
        </li>
      );
    }

    function renderSection(titulo, items){
      return (
        <div className="zv-admin-sidebar-section">
          <div className="zv-admin-sidebar-section-title">{titulo}</div>
          <ul className="zv-admin-sidebar-list">
            {items.map(renderItem)}
          </ul>
        </div>
      );
    }

    return(
      <aside className="col-md-3 col-lg-2 zv-admin-sidebar">
        <div
          className="offcanvas-md offcanvas-end zv-admin-sidebar-offcanvas"
          tabIndex="-1"
          id="sidebarMenu"
          aria-labelledby="sidebarMenuLabel"
        >
          <div className="offcanvas-header border-bottom">
            <div className="zv-admin-sidebar-mobile-user">
              <img
                src={avatar}
                alt={`Avatar de ${username}`}
                className="zv-admin-sidebar-avatar zv-admin-sidebar-avatar-sm"
              />
              <div>
                <h5 className="offcanvas-title fw-bold mb-0" id="sidebarMenuLabel">Hola @{username}</h5>
                <small className="text-muted">Panel administrativo</small>
              </div>
            </div>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              data-bs-target="#sidebarMenu"
              aria-label="Cerrar menú"
            ></button>
          </div>

          <div className="offcanvas-body p-0">
            <div className="zv-admin-sidebar-inner">

              <div className="zv-admin-sidebar-brand d-none d-md-flex">
                <img
                  src={avatar}
                  alt={`Avatar de ${username}`}
                  className="zv-admin-sidebar-avatar"
                  width="54"
                  height="54"
                />
                <div className="zv-admin-sidebar-brand-info">
                  <div className="zv-admin-sidebar-brand-title">Hola @{username}</div>
                  <div className="zv-admin-sidebar-brand-subtitle">Panel administrativo</div>
                </div>
              </div>

              <nav className="zv-admin-sidebar-nav">
                <ul className="zv-admin-sidebar-list mb-3">
                  {renderItem({ label: "Dashboard", icono: "bi-speedometer2", to: "/admin" })}
                </ul>

                {renderSection("Operación", menuOperacion)}
                {!esSoporte && renderSection("Pagos", menuPagos)}
                {renderSection("Administración", menuAdmin)}
              </nav>

              <div className="zv-admin-sidebar-footer">
                <button onClick={handleLogOut} className="zv-admin-sidebar-logout" type="button">
                  <span className="zv-admin-sidebar-icon">
                    <i className="bi bi-box-arrow-left"></i>
                  </span>
                  <span>Cerrar sesión</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </aside>
    )
}

export default SidebarAdmin;